// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__34rqi","content":"RecentSearches_content__2WkzB"};